import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_MONITOR_STORAGE_ACCOUNT,
  GET_AZURE_MONITOR_STORAGE_ACCOUNT_SUCCESS,
  GET_AZURE_MONITOR_STORAGE_ACCOUNT_ERROR,
  // GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES,
  // GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_SUCCESS,
  // GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_ERROR,
} from "./constant";

import {
  getAzureMonitorStorageAccountApi,
  // getAzureMonitorApplicationResourceNamesApi,
} from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureMonitorStorageAccountList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureMonitorStorageAccountApi, params, provider);
    yield put({ type: GET_AZURE_MONITOR_STORAGE_ACCOUNT_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_MONITOR_STORAGE_ACCOUNT_ERROR, error });
  }
}

// function* getAzureMonitorApplicationResourceNamesList(params) {
//   try {
//     const data = yield call(getAzureMonitorApplicationResourceNamesApi, params);
//     yield put({
//       type: GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_SUCCESS,
//       data,
//     });
//   } catch (error) {
//     yield put({
//       type: GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_ERROR,
//       error,
//     });
//   }
// }

/**
 * Get Login Saga
 */
export function* manageAzureMonitorStorageAccountSaga() {
  yield takeLatest(
    GET_AZURE_MONITOR_STORAGE_ACCOUNT,
    getAzureMonitorStorageAccountList
  );
  // yield takeLatest(
  //   GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES,
  //   getAzureMonitorApplicationResourceNamesList
  // );
}
